import * as React from "react";
import type { SVGProps } from "react";
const SvgIconHeart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.28 1.6q-.69.05-1.36.38C1.22 2.8.23 4.85.6 6.73c.15.73.52 1.44 1.03 1.99.22.23 6 5.57 6.08 5.62.16.09.38.09.54 0 .09-.05 5.66-5.2 6.02-5.56q.49-.48.76-1.06c.53-1.05.57-2.29.11-3.44-.4-1.01-1.14-1.83-2.06-2.29-.37-.18-.7-.29-1.11-.35-.25-.04-.83-.04-1.08 0-.63.1-1.2.31-1.8.68-.3.2-.76.55-1.02.81l-.09.09-.05-.05-.22-.2Q6.32 1.7 4.8 1.6c-.26-.02-.26-.02-.52 0m-.07 1.16q-.85.13-1.5.74c-.56.55-.92 1.26-1.01 2.05-.02.18-.02.57 0 .74.08.66.4 1.28.9 1.78l5.36 4.96c.03.03.06 0 2.78-2.52 1.52-1.4 2.8-2.61 2.87-2.69q.5-.56.66-1.31c.05-.23.06-.69.03-.94-.08-.76-.41-1.45-.94-1.98q-.48-.48-1.06-.7c-.26-.08-.41-.12-.7-.14-.99-.07-2.08.48-3.03 1.51-.23.25-.32.32-.46.35-.23.04-.39-.02-.59-.23-.23-.25-.5-.51-.66-.65q-.9-.78-1.85-.96c-.19-.03-.63-.04-.8-.01"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconHeart;
